export const calculatePercentage = ({ percentage, total }) => {
  return (percentage / 100) * total
}
